<template>
<router-link :to="{name: meta.name}" @click.native="changeMenuActive">
  <div class="flex items-center th-sidebar-group th-hover-pointer" :class="classAdditionalParent">
    <div class="icon" :style="{ 'margin-right': sidebarIsExpanded ? '16px' : 0 }">
      <home-icon :style="{ 'margin-left': !sidebarIsExpanded ? '1px' : null }" v-if="meta.icon === 'home'" />
      <search-icon :style="{ 'margin-left': !sidebarIsExpanded ? '2px' : null }" class="mb-1" v-if="meta.icon === 'search'" />
      <bookmark-icon :style="{ 'margin-left': !sidebarIsExpanded ? '2px' : null }" class="mb-1" v-if="meta.icon === 'bookmark'" />
      <screen-icon :style="{ 'margin-left': !sidebarIsExpanded ? '2px' : null }" class="mb-1" v-if="meta.icon === 'screen'" />
    </div>
    <div class="title" :style="{ 'font-size': !sidebarIsExpanded ? '12px' : null }" :class="!sidebarIsExpanded ? 'text-center' : null">
      {{meta.title}}
    </div>
  </div>
</router-link>
</template>

<script>
const HomeIcon = () => import('@/components/Icon/Home')
const SearchIcon = () => import('@/components/Icon/Search')
const BookmarkIcon = () => import('@/components/Icon/Bookmark')
const ScreenIcon = () => import('@/components/Icon/Screen')

export default {
  props: {
    meta: { type: Object },
    active: { type: Boolean },
  },
  components: { HomeIcon, SearchIcon, BookmarkIcon, ScreenIcon },
  methods: {
    changeMenuActive() {
      if (this.currentMenu !== this.meta.name) this.$store.commit('SET_STATE', { currentMenu: this.meta.name })
      // this.$router.push({ name: this.meta.name })
    },
  },
  computed: {
    currentMenu() { return this.$store.state.currentMenu },
    sidebarIsExpanded() { return this.$store.state.sidebarIsExpanded },
    classAdditionalParent() {
      let classes = []
      if (this.active) classes.push('th-sidebar-group__active')
      if (!this.sidebarIsExpanded) classes = classes.concat(['flex-col', 'items-center'])
      return classes
    },
  },
}
</script>

<style lang="scss">
@import '@/components/Kit/utils.scss';

.th-sidebar-group {
  padding: 10px 23.5px;
  color: $black-blue;
  border-radius: 4px;

  &:hover {
    background-color: #F5F6F8;
  }

  &__active {
    background-color: #F5F6F8;
    // border-radius: 4px;

    .title {
      color: #3E4095;
    }
  }

  div {
    font-weight: 600;
    font-size: 14px;
    // margin: 0!important;
    line-height: 19px;
  }

  .icon {
    min-width: 26px;
  }

  .title {

  }
}
</style>
